/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-15 11:31:42
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-17 15:13:06
 * @FilePath: /wemeet-web-activity/src/pages/questions/utils/form2Storage.ts
 * @Description: 表单数据保存
 */
import { QuestionType, AnswerType } from "../type/index";
const STORAGE_KEY = 'EVENT_PLACE_BUYER_QUESTION';
const form2Json = (eventId, ticketId, formData) => JSON.stringify({
  [`${eventId}_${ticketId}`]: formData
});
export const getAnswerFromForm = formData => {
  const storageData = formData.map(item => {
    let {
      answer = []
    } = item;
    if (item.answer_type === AnswerType.CHECKBOX && answer) {
      if (answer instanceof Array) {
        answer = answer.filter(item => item !== '').join(';');
      }
    }
    const data = {
      question_id: item.question_id || '',
      answer
    };
    if (item.question_type === QuestionType.PHONE) {
      // 兼容后台回填的手机号是空格的情况，要改成;
      if (data.answer?.indexOf?.(' ') > -1) {
        data.answer = data.answer.replace?.(' ', ';');
      }
      data.answer = data.answer?.replace?.('+', '');
      if (item.verification_code) {
        data.verification_code = item.verification_code;
      }
    }
    return data;
  });
  return storageData;
};
export const form2Storage = (eventId, ticketId, formData) => {
  if (!(eventId && ticketId && formData)) {
    return false;
  }
  const storageData = getAnswerFromForm(formData);
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(STORAGE_KEY, form2Json(eventId, ticketId, storageData));
    return true;
  }
};
export const getFormFromStorage = (eventId, ticketId) => {
  if (!(eventId && ticketId && typeof window.sessionStorage === 'undefined')) {
    return null;
  }
  const formId = `${eventId}_${ticketId}`;
  let storageData = sessionStorage.getItem?.(STORAGE_KEY);
  if (storageData) {
    try {
      storageData = JSON.parse(storageData);
      const formData = storageData?.[formId];
      return formData;
    } catch (e) {
      // 错误处理
    }
  }
};